module.exports = __webpack_public_path__ + "img/m-banner-ovpsmbeg-ko-KR.f865106f.png";